import economyMode from './economy-mode-reducer';

export * from './economy-mode-reducer';
export default economyMode;
